function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Button } from '../Button';
import styles from '@dtsl/css-close-button/dist/index.module.css';
import Cross from '@dtsl/icons/dist/icons/react/X';
function CloseButton(props) {
  const {
    className = '',
    size = '',
    ...restprops
  } = props;
  const closeButtonClasses = classNames({
    [styles['sib-close-btn']]: true,
    [styles[`sib-btn_size--${size}`]]: !!size,
    [styles['sib-btn']]: true,
    [styles['sib-btn_icon-stand-alone']]: true,
    [className]: !!className
  });
  return /*#__PURE__*/React.createElement(Button, _extends({
    ariaLabel: "close button"
  }, restprops, {
    iconAlone: true,
    icon: /*#__PURE__*/React.createElement(Cross, {
      "aria-hidden": "true"
    }),
    className: closeButtonClasses
  }));
}
CloseButton.propTypes = {
  className: PropTypes.string,
  size: PropTypes.string,
  disabled: PropTypes.bool
};
export default CloseButton;